import { cn } from '../../../lib/cn';

export default function QuizTopBar({
  title,
  courseContext,
  questionNumber,
  totalQuestions,
}) {
  return (
    <header
      className={cn(
        'flex items-center justify-between',
        'border-b border-gray-200 dark:border-gray-700',
        'bg-white dark:bg-gray-900',
        'px-6 py-3',
        'pr-14', // leave room for the fixed ThemeToggle at top-right
      )}
    >
      <div className="flex items-baseline gap-3 min-w-0">
        <h1 className="text-sm font-semibold text-gray-900 dark:text-white truncate">
          {title}
        </h1>
        {courseContext && (
          <span className="text-xs text-gray-500 dark:text-gray-400 truncate">
            {courseContext}
          </span>
        )}
        {questionNumber && totalQuestions && (
          <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
            • Question {questionNumber} of {totalQuestions}
          </span>
        )}
      </div>
    </header>
  );
}
